import AppModal from "../modal";
import SignInModalContent from "./sign-in-modal-content";

interface Props {
  onClose: () => void;
  onSignedIn: () => void;
  visible: boolean;
}

export default function SignInModal({ onClose, onSignedIn, visible }: Props) {
  return (
    <AppModal onClose={onClose} visible={visible}>
      <SignInModalContent onClose={onClose} onSignedIn={onSignedIn} />
    </AppModal>
  );
}
